<template>
    <div class="trav-accordian" @click="$emit('setHeight',$event)">
        <div class="sa-trigger" @click="open=!open" :class="open?'active':''">
          <i class="icon-right-arrow" :class="{open:open}"></i>
          <span class="sa-trigger-tit">{{title}}</span>
        </div>
        <transition>
            <div class="sa-trigger-cnt" v-show="open">
                <slot></slot>
            </div>
        </transition>
    </div>
</template>
<script>
export default {
  props: ['title', 'iconClass'],
  data () {
    return {
      open: false
    }
  }
}
</script>